<div class="p-field-checkbox">
  <p-inputSwitch
    class="input-switch"
    [formControl]="formControl"
  ></p-inputSwitch>
  <label [for]="field.id">{{ props.label }}</label>
  <div
    *ngIf="props.tooltip"
    class="symbol-info tooltip-icon"
    [pTooltip]="props.tooltip"
  ></div>
</div>
